import React from 'react';

const NotFound = (props) => {
	window.location = window.location.protocol + '//' + window.location.hostname;
	return null;
}
export default NotFound